import _ from "lodash";
import { mapMutations } from "vuex";

export default {
  methods: {
    updateBreadCrumbs() {
      const params = this.$options.breadcrumbs.map(({ key, valueKey }) => {
        return { key, value: _.get(this, valueKey) };
      });

      this.updateCrumbsParams(params);
    },
    ...mapMutations({
      updateCrumbsParams: "breadcrumbs/updateCrumbsParams",
    }),
  },
};
